import axios from "axios";
import setAuthToken from "../utils/setAuthToken";
import jwt_decode from "jwt-decode";
import {
  GET_ERRORS,
  CLEAR_ERRORS,

  // SET_CURRENT_ADVERTISEMENT,
  // SET_CURRENT_ADVERTISEMENTS,
  // CREATE_ADVERTISEMENT,
  // MODIFY_ADVERTISEMENT,
  // REMOVE_ADVERTISEMENT,
  // CHANGE_ADVERTISEMENT_STATUS,

  MODIFY_ACCOMMODATION,
  INSERT_ACCOMMODATION,
  DELETE_ACCOMMODATION,
  CHANGE_ACCOMMODATION_STATUS,
  DELETE_ACCOMMODATIONS_FOR_PROPERTY,

  SET_CURRENT_ACCOMMODATIONS,
  MODIFY_PROPERTY,
  INSERT_PROPERTY,
  DELETE_PROPERTY,
  CHANGE_PROPERTY_STATUS,
  SET_CURRENT_PROPERTIES,

  SET_STATUS_MESSAGE,
  CLEAR_STATUS_MESSAGE,

  SET_IS_LOADING,
  SET_CURRENT_DEALS,
  SET_DOMAIN_DATA
} from "./types";


export const clearStatusMessage = () => dispatch => {
  dispatch({ type: CLEAR_STATUS_MESSAGE });
};

export const getDealSpecials = qobj => dispatch => {
  //console.log("getAdvertisements");
  //dispatch({ type: SET_IS_LOADING, payload: true });
  //let link = "/api/advertise/advertisements/" + bizid;
  let link = "/api/deals/deal_specials";

  axios
    .post(link, qobj)
  dispatch({
    type: SET_IS_LOADING,
    payload: { isloading: true }
  });

  axios
    .post(link, qobj)
    // .then(res => console.log(res.data))
    .then(res => {
      //console.log("getAdvertisements we have success", res.data);
      //this.setState({ businesses: res.data });
      // console.log('actions res length ', res.data.length);
      if (res.data.length > 100) {
        dispatch({
          type: GET_ERRORS,
          payload: { message: 'Too many deals to display (' + res.data.length + ').  Please refine your query parameters' }
        });
        return;
      }
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_IS_LOADING,
        payload: { isloading: false }
      });
      dispatch({ type: SET_CURRENT_DEALS, payload: res.data });
    })
    .catch(err => {
      //console.log("advertise actions error ", err);
      dispatch({ type: SET_IS_LOADING, payload: false });
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    });
  // }
};


export const queryDeals = qobj => dispatch => {
  //console.log("getAdvertisements");
  //dispatch({ type: SET_IS_LOADING, payload: true });
  //let link = "/api/advertise/advertisements/" + bizid;
  //console.log('queryDeals', qobj);
  let link = "/api/deals/deals";

  axios
    .post(link, qobj)
  dispatch({
    type: SET_IS_LOADING,
    payload: { isloading: true }
  });

  axios
    .post(link, qobj)
    // .then(res => console.log(res.data))
    .then(res => {
      //console.log("getAdvertisements we have success", res.data);
      //this.setState({ businesses: res.data });
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_IS_LOADING,
        payload: { isloading: false }
      });
      if (res.data.length > 100) {
        dispatch({
          type: GET_ERRORS,
          payload: { message: 'Too many deals to display (' + res.data.length + ').  Please refine your query parameters' }
        });
        return;
      }
      if (res.data.length === 0) {
        dispatch({
          type: GET_ERRORS,
          payload: { message: 'No deals found.  Please refine your query parameters' }
        });
        return;
      }
      dispatch({ type: SET_CURRENT_DEALS, payload: res.data });

    })
    .catch(err => {
      //console.log("advertise actions error ", err);
      dispatch({ type: SET_IS_LOADING, payload: false });
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    });
  // }
};

// using query deals for everything
/*
export const wildcardSearchDeals = obj => dispatch => {
  let term = obj['searchterm']
  let link = "/api/deals/search_wc"; ///" + term;

  axios
    .post(link, obj)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_IS_LOADING,
        payload: { isloading: false }
      });
      if (res.data.length > 100) {
        dispatch({
          type: GET_ERRORS,
          payload: { message: 'Too many deals to display (' + res.data.length + ').  Please refine your query parameters' }
        });
        return;
      }
      dispatch({ type: SET_CURRENT_DEALS, payload: res.data });
    })
    .catch(err => {
      //console.log("advertise actions error ", err);
      dispatch({ type: SET_IS_LOADING, payload: false });
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    });
  // }
};
*/

export const getDomainData = () => dispatch => {
  let link = "/api/deals/domaindata";
  axios
    .get(link)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_DOMAIN_DATA, payload: res.data });
      let link2 = "/api/deals/deal_specials";
      let qobj = { which: 'checkin' };
      axios
        .post(link2, qobj)
        // .then(res => console.log(res.data))
        .then(res2 => {
          dispatch({ type: SET_CURRENT_DEALS, payload: res2.data });
        })
        .catch(err => {
        });
    })
    .catch(err => {
      //console.log("advertise actions error ", err);
      dispatch({ type: SET_IS_LOADING, payload: false });
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    });
  // }
};

export const adjustdates_getDomainData = () => dispatch => {
  let link = "/api/deals/domaindata";
  axios
    .get(link)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_DOMAIN_DATA, payload: res.data });
      let dd = res.data;
      let mindate = new Date('2040-01-10');
      let maxdate = new Date('2000-01-01');
      dd.forEach(el => {
        let sd = new Date(el['start_date']);
        if (sd < mindate) mindate = sd;
      });
      let link3 = "/api/modify/adjust_dates";
      let qobj = { mindate: mindate };
      axios
        .post(link3, qobj)
        .then(res2 => {
          console.log('return from adjust dates');
          // dispatch({ type: SET_CURRENT_DEALS, payload: res2.data });
          let link2 = "/api/deals/deal_specials";
          let qobj = { which: 'checkin' };
          axios
            .post(link2, qobj)
            .then(res3 => {
              dispatch({ type: SET_CURRENT_DEALS, payload: res3.data });
            })
            .catch(err => {
            });
        })
        .catch(err => {
        });
    })
    .catch(err => {
      //console.log("advertise actions error ", err);
      dispatch({ type: SET_IS_LOADING, payload: false });
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      });
    });
  // }
};


//******************************************************
//******************************************************
// ACCOMMODATION METHODS
//******************************************************
//******************************************************



export const modifyAccommodation = (accomData, history) => dispatch => {
  console.log("modifyAccommodation  in actions ", accomData);
  axios
    .post("/api/modify/modify_accommodation", accomData)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_STATUS_MESSAGE,
        payload: { message: "Accommodation Update Successful" }
      });
      let po = {};
      console.log('actions update return data ', res.data);
      //  po['resdata'] = res.data;
      // po['updateobj'] = accomData;
      dispatch({ type: MODIFY_ACCOMMODATION, payload: res.data });
      // history.push("/dashboard");
    })
    // thunk lets us do a dispatch
    // .then(res => console.log(res.data))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};


export const getAccommodationsForProperty = (propid, history) => dispatch => {
  //console.log("modify advertisement in actions ", advertisementData);
  let link = "/api/deals/admin_get_accommodations";
  let qobj = {};
  qobj['property_key'] = propid;
  axios
    .post(link, qobj)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      // dispatch({
      //   type: SET_STATUS_MESSAGE,
      //   payload: { message: "Accommodation Update Successful" }
      // });
      dispatch({ type: SET_CURRENT_ACCOMMODATIONS, payload: res.data });
      // history.push("/dashboard");
    })
    // thunk lets us do a dispatch
    // .then(res => console.log(res.data))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const insertAccommodation = (accomdata, history) => dispatch => {
  // console.log("insertAccommodation  in actions ", accomdata);
  axios
    .post("/api/modify/insert_accommodation", accomdata)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_STATUS_MESSAGE,
        payload: { message: "Accommodation Insert Successful" }
      });
      let po = {};
      //  po['resdata'] = res.data;
      // po['updateobj'] = accomData;
      dispatch({ type: INSERT_ACCOMMODATION, payload: res.data });
      // history.push("/dashboard");
    })
    // thunk lets us do a dispatch
    // .then(res => console.log(res.data))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const deleteAccommodation = (accomid, history) => dispatch => {
  let qobj = {};
  qobj['_id'] = accomid;
  axios
    .post("/api/modify/delete_accommodation", qobj)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_STATUS_MESSAGE,
        payload: { message: "Accommodation Delete Successful" }
      });

      dispatch({ type: DELETE_ACCOMMODATION, payload: accomid });
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const changeAccommodationStatus = (acomid, status) => dispatch => {
  //console.log("modify advertisement in actions ", advertisementData);
  let link = `/api/modify/change-accommodation-status/${acomid}/${status}`;
  //console.log("adveractions changebusinesssttus", link);
  let rdata = { acomid: acomid, status: status };
  axios
    .get(link)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_STATUS_MESSAGE,
        payload: { message: "Accommodation Status Update Successful" }
      });
      dispatch({ type: CHANGE_ACCOMMODATION_STATUS, payload: rdata });
    })
    // thunk lets us do a dispatch
    // .then(res => console.log(res.data))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

//******************************************************
//******************************************************
// PROPERTY METHODS
//******************************************************
//******************************************************

export const modifyProperty = (propdata, history) => dispatch => {
  //  console.log("modifyProperty  in actions ", propdata);
  axios
    .post("/api/modify/modify_property", propdata)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_STATUS_MESSAGE,
        payload: { message: "Property Update Successful" }
      });
      let po = {};
      console.log('update property return data ', res.data);
      //  po['resdata'] = res.data;
      // po['updateobj'] = accomData;
      dispatch({ type: MODIFY_PROPERTY, payload: res.data });
      // history.push("/dashboard");
    })
    // thunk lets us do a dispatch
    // .then(res => console.log(res.data))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};
export const insertProperty = (propdata, history) => dispatch => {
  console.log("insertProperty  in actions ", propdata);
  axios
    .post("/api/modify/insert_property", propdata)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_STATUS_MESSAGE,
        payload: { message: "Property Insert Successful" }
      });
      let po = {};
      console.log('insertProperty  return data ', res.data);
      //  po['resdata'] = res.data;
      // po['updateobj'] = accomData;
      dispatch({ type: INSERT_PROPERTY, payload: res.data });
      // history.push("/dashboard");
    })
    // thunk lets us do a dispatch
    // .then(res => console.log(res.data))
    .catch(err => {
      console.log('we have an error inserting', err);
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    }
    );
};

export const deleteProperty = (property, history) => dispatch => {
  let qobj = {};
  let propid = property['_id'];
  qobj['_id'] = propid;
  qobj['photoary'] = property['photoary'];
  axios
    //.post("/api/modify/delete_property", qobj)
    .post("/api/modify/delete_property", property)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });

      dispatch({ type: DELETE_PROPERTY, payload: propid });
      let qobj2 = {};
      qobj2['property_key'] = propid;
      axios
        .post("/api/modify/delete_accommodations_for_property", qobj2)
        .then(res => {
          dispatch({
            type: SET_STATUS_MESSAGE,
            payload: { message: "Property And Accommodations Deleted Successful" }
          });
          dispatch({ type: DELETE_ACCOMMODATIONS_FOR_PROPERTY, payload: propid });
        }).catch(err =>
          dispatch({
            type: GET_ERRORS,
            payload: err.response.data
          })
        )
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};


export const changePropertyStatus = (propid, status) => dispatch => {
  //console.log("modify advertisement in actions ", advertisementData);
  let link = `/api/modify/change-property-status/${propid}/${status}`;
  //console.log("adveractions changebusinesssttus", link);
  let rdata = { propid: propid, status: status };
  axios
    .get(link)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_STATUS_MESSAGE,
        payload: { message: "Property Status Update Successful" }
      });
      dispatch({ type: CHANGE_PROPERTY_STATUS, payload: rdata });
    })
    // thunk lets us do a dispatch
    // .then(res => console.log(res.data))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const zzdeleteProperty = (propid, history) => dispatch => {
  let qobj = {};
  qobj['_id'] = propid;
  axios
    .post("/api/modify/delete_property", qobj)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_STATUS_MESSAGE,
        payload: { message: "Property Delete Successful" }
      });

      dispatch({ type: DELETE_PROPERTY, payload: propid });
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const getPropertiesForCompany = (coid, history) => dispatch => {
  //console.log("modify advertisement in actions ", advertisementData);
  //let link = "/api/deals/admin_get_accommodations";
  //let qobj = {};
  // qobj['property_key'] = propid;
  let link = "/api/deals/admin_get_properties";

  let qobj = {};
  qobj['company_id'] = coid;
  axios
    .post(link, qobj)
    .then(res => {
      dispatch({ type: CLEAR_ERRORS });
      // dispatch({
      //   type: SET_STATUS_MESSAGE,
      //   payload: { message: "Accommodation Update Successful" }
      // });
      dispatch({ type: SET_CURRENT_PROPERTIES, payload: res.data });
      // history.push("/dashboard");
    })
    // thunk lets us do a dispatch
    // .then(res => console.log(res.data))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

/*
getProperties = (e) => {
    e.preventDefault();
    let link = "/api/deals/admin_get_properties";
    let cid = this.props.auth.user.company_id;
    let qobj = {};
    qobj['company_id'] = cid;
    axios
      .post(link, qobj)
      //.get(link2)
      .then(res => {
        //  console.log(res);
        let rstr = JSON.stringify(res.data);
        this.setState({ properties_ary: res.data, selected_accommodation: null, displaystr: rstr });
      }).catch(err => {
        console.log("advertise actions error ", err);
      });

  }
  */

// getAccommodations = (e, propid) => {
//   e.preventDefault();
//   let link = "/api/deals/admin_get_accommodations";
//   let qobj = {};
//   qobj['property_key'] = propid;
//   axios
//     .post(link, qobj)
//     //.get(link2)
//     .then(res => {
//       //  console.log(res);
//       let rstr = JSON.stringify(res.data);
//       this.setState({ accommodations_ary: res.data, selected_property: null, selected_accommodation: null, displaystr: rstr });
//     }).catch(err => {
//       console.log("advertise actions error ", err);

//     });

// }




// WEBPACK FOOTER //
// ./src/actions/dealsActions.js